/* global axios */
import ApiClient from './ApiClient';

// v42: cliente do PROXY do simulador-api (Rails -> simulador-api:8811).
// A simulacao roda no servico externo; aqui so criar/poll/listar — respostas
// rapidas. Espelha o padrao do cltSimulador.js.
class SimuladorApiAPI extends ApiClient {
  constructor() {
    super('simulador_api', { accountScoped: true });
  }

  get(path, params = {}) {
    return axios.get(`${this.url}/${path}`, { params });
  }

  post(path, body = {}, headers = {}) {
    return axios.post(`${this.url}/${path}`, body, { headers });
  }

  delete(path, params = {}) {
    return axios.delete(`${this.url}/${path}`, { params });
  }

  // CSV como blob (o navegador baixa via URL.createObjectURL)
  csv(path, params = {}) {
    return axios.get(`${this.url}/${path}`, { params, responseType: 'blob' });
  }
}

export default new SimuladorApiAPI();
